<div class="container-close">
    <a (click)="closeModalReport()" title="Fechar">
        <i class="material-icons">close</i>
    </a>
</div>
<h2>Selecione a Região</h2>
<div class="container-text">
    <ul class="list-region">
        <li>
            <input type="radio" name="region" value="1" (change)="selectRegion($event)"> Norte
        </li>
        <li>
            <input type="radio" name="region" value="2" (change)="selectRegion($event)"> Nordeste
        </li>
        <li>
            <input type="radio" name="region" value="3" (change)="selectRegion($event)"> Sudeste
        </li>
        <li>
            <input type="radio" name="region" value="4" (change)="selectRegion($event)"> Sul
        </li>
        <li>
            <input type="radio" name="region" value="5" (change)="selectRegion($event)"> Centro-Oeste
        </li>
    </ul>
</div>
<h2>Selecione o Tipo de Arquivo</h2>
<div class="container-text">
    <ul class="list-region">
        <li>
            <input type="radio" name="fileType" value="1" (change)="selectFileType($event)"> Excel
        </li>
        <li>
            <input type="radio" name="fileType" value="2" (change)="selectFileType($event)"> CSV
        </li>
    </ul>
</div>
<div class="container-footer">
    <button class="btn btn-primary" [disabled]="regionCode == 0 && fileType == 0" (click)="close()">Gerar Relatório</button>
</div>